






import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { firebase } from '@/core/init'

@Component({})
export default class CreateSuperAdminPage extends Vue {

  message = ''
  async created() {
    try {
      const authCreateSuperAdmin = firebase.functions.httpsCallable('authCreateSuperAdmin')
      const result = await authCreateSuperAdmin()
      this.message = result.data
    }
    catch(e) { 
      this.message = e.toString()
    }
  }
}
